// Search helpers shared by the searchable field pickers (lists and trees).

const COMBINING_MARKS = /[̀-ͯ]/g;
const NON_ALPHANUMERIC = /[^\p{L}\p{N}]+/gu;

// normalizeSearch lowers the case, expands the œ/æ ligatures, strips the
// accents and turns every run of punctuation or spaces into a single space,
// so that "Date d’Échéance" and "date d'echeance" compare equal.
export function normalizeSearch(text: string): string {
    return text
        .toLowerCase()
        .replace(/œ/g, "oe")
        .replace(/æ/g, "ae")
        .normalize("NFD")
        .replace(COMBINING_MARKS, "")
        .replace(NON_ALPHANUMERIC, " ")
        .trim();
}

// matchesSearch tells whether every word of the query appears in the text,
// in any order, once both are normalized. An empty query matches everything.
export function matchesSearch(text: string, query: string): boolean {
    const normalizedQuery = normalizeSearch(query);
    if (normalizedQuery === "") {
        return true;
    }
    const normalizedText = normalizeSearch(text);
    return normalizedQuery.split(" ").every(word => normalizedText.includes(word));
}
